import React, { useState } from 'react'
import { Redirect } from 'react-router';

//import firebase from '../FirebaseConfig.js'
import analyticsHelper from '../AnalyticsHelper.js'

import HTPillTag from './HTPillTag'

function HTContentListRow (props) {

  const content = props.content

  const tags = content.tags.map(function (oneTag,index) {
    return (<HTPillTag key={index} title={oneTag} onClick={(tag)=>{console.log(tag+" clicked")}}/>)
    //return (<div className="tag" key={index}>{oneTag}</div>)
  })

  // set up state vars
  const [clicked, setClicked] = useState(false);

  // if the row is clicked view the content
  if (clicked) {
    //firebase.analytics().logEvent('to: '+content.path + " from list row");
    analyticsHelper.genEvent(analyticsHelper.EVENT_SELECT, analyticsHelper.SELECT_LIST_ROW, content.path)
    return (<Redirect to={"/lesson/"+content.path} push={true} />)
  }

  return (
    <div className="content_row" onClick={() => setClicked(true)}>
      <div className="content_row_top">
        <div className="content_row_title">{content.title}</div>
        {/*<div className="content_row_date">Updated {content.date_modified}</div>*/}
      </div>
      <div className="content_row_bottom">
        {tags}
      </div>
    </div>
  )
}

export default HTContentListRow

/*onClick={(event) => props.handleClick(content.url)}*/



// WEBPACK FOOTER //
// src/components/HTContentListRow.js